module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "spw-light.9bb4d411.svg";